import moment from "moment";
import React, { memo, useEffect, useRef, useState, useMemo } from "react";
import { Image } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, useHistory, useLocation } from "react-router-dom";
import Stop from "../assets/icons/stop-circle.svg";
import MobileMenu from "../assets/images/Moblie Menu.svg";
import messageImage from "../assets/images/messageImage.svg";
import editIcon from "../assets/icons/editIcon.svg";
import logOut from "../assets/icons/logOut.svg";
import { ReactComponent as Search } from "../assets/images/search.svg";
import {
  GetActiveTimeSessionOnPlanboard,
  OpenTimerFromHeader,
  StopTimerFromHeader,
  user_logout,
} from "../redux/actions/action";
import { getChatRooms } from "../redux/actions/chatActions";
import "../assets/styles/local/header.css";
import { handleGeneralNotification } from "../utils/helpers/notifications";
import { fetchScreenTranslations } from "../utils/helpers/translations";
import useScreenSize from "../utils/hooks/useScreenSizeHook";
// import UserNotificationMenu from "../components/Notifications/UserNotificationMenu";
import NotificationBell from "../components/Notifications/Notification";

const Header = (props) => {
  const [totalMessages, setTotalMessages] = useState(0);
  const [active, setActive] = useState(false);
  const [showpopup, setShowpopup] = useState(false);
  const history = useHistory();
  const dispatch = useDispatch();
  const location = useLocation();
  const path = location.pathname;
  const userID = window.localStorage.getItem("userid");
  const userjobpost = window.localStorage.getItem("jobpost");
  const userimag = window.localStorage.getItem("userimageurl");
  const userfirstname = window.localStorage.getItem("firstname");
  const userlastname = window.localStorage.getItem("lastname");
  const initials = window.localStorage.getItem("initials");
  const [session1, setSession1] = useState("00");
  const [session2, setSession2] = useState("00");
  const [session3, setSession3] = useState("00");
  const [taskName, setTaskName] = useState("");
  const [taskId, setTaskId] = useState("");
  const logoutData = useSelector((state) => state.user.userlogout);
  const chatRoomsResponse = useSelector((state) => state?.chat?.chatRooms);
  const [fetchTranslationDatas, setFetchTranslationDatas] = useState({});
  const t = (key) => fetchTranslationDatas?.[key] || "";
  const initialRender = React.useRef(true);
  const FetchCompanyDetails1 = useSelector(
    (state) => state.user.FetchCompanyDetails,
  );
  const GetActiveTimeSessionOnPlanboardResponse = useSelector(
    (state) => state.user.GetActiveTimeSessionOnPlanboardResponse,
  );
  const [textcolor, setTextcolor] = useState("");
  var today = new Date();
  var date =
    today.getFullYear() + "-" + (today.getMonth() + 1) + "-" + today.getDate();
  const finDate = new Date(date);
  var date = finDate.toString().split(" ");
  const [FetchCompanyThemRes, setFetchCompanyThemRes] = useState([]);
  const screenSize = useScreenSize();
  const [timerRunning, setTimerRunning] = useState(false);

  const isWebView = () => {
    return (
      typeof window.ReactNativeWebView !== "undefined" ||
      navigator.userAgent.includes("wv")
    );
  };

  useEffect(() => {
    fetchScreenTranslations("Add-Task").then((res) => {
      setFetchTranslationDatas(res);
    });
  }, [props.reRenderTranslate]);

  useEffect(() => {
    if (path === "/planboard") {
      dispatch(
        GetActiveTimeSessionOnPlanboard(
          window.localStorage.getItem("userid"),
          moment(new Date()).format("DD/MM/YYYY"),
          `${new Date().getHours().toString().padStart(2, "0")}:${new Date()
            .getMinutes()
            .toString()
            .padStart(2, "0")}:${new Date()
            .getSeconds()
            .toString()
            .padStart(2, "0")}`,
        ),
      );
    }
  }, [path]);

  function timeConvert(n) {
    var num = n;
    var hours = num / 60;
    var rhours = Math.floor(hours).toString().padStart(2, "0");
    var minutes = (hours - rhours) * 60;
    var rminutes = Math.round(minutes).toString().padStart(2, "0");
    var seconds = (minutes - rminutes) * 60;
    var rseconds = Math.round(seconds).toString().padStart(2, "0");
    setSession1(rhours);
    setSession2(rminutes);
    setSession3(Math.abs(rseconds));
    return `${rhours}:${rminutes}:${rseconds}`;
  }

  const [timerType, setTimerType] = useState("");

  useEffect(() => {
    if (GetActiveTimeSessionOnPlanboardResponse?.status === true) {
      let date =
        GetActiveTimeSessionOnPlanboardResponse?.data?.startDate.split("/");
      date = `${date[2]}-${date[1]}-${date[0]}`;
      date = `${date}T${GetActiveTimeSessionOnPlanboardResponse?.data?.startTime}`;
      let diff = new Date().getTime() - new Date(date).getTime();
      timeConvert(diff / 60000);
      setTaskName(GetActiveTimeSessionOnPlanboardResponse?.data?.taskName);
      setTaskId(GetActiveTimeSessionOnPlanboardResponse?.data?.taskId);
      setTimerType(GetActiveTimeSessionOnPlanboardResponse?.data?.type);
      setTimerRunning(true);
    } else setTimerRunning(false);
  }, [GetActiveTimeSessionOnPlanboardResponse]);

  useEffect(() => {
    let counter = setInterval(() => {
      if (session2 >= 59) {
        if (session3 >= 59) {
          setSession1((hour) => (+hour + 1).toString().padStart(2, "0"));
          setSession2("00");
          setSession3("00");
          return;
        }
      }
      if (session3 >= 59) {
        setSession2((minute) => (+minute + 1).toString().padStart(2, "0"));
        setSession3("00");
        return;
      }
      setSession3((second) => (+second + 1).toString().padStart(2, "0"));
    }, 1000);
    return () => clearInterval(counter);
  }, [session3]);

  React.useEffect(() => {
    if (!initialRender.current) {
      if (logoutData != null) {
        if (logoutData?.status == true) {
          // window.location.reload();
          const logoutUrl = window.localStorage.getItem("logoutUrl");
          window.localStorage.clear();
          window.localStorage.clear();
          history.replace(logoutUrl);
        }
      }
    } else {
      initialRender.current = false;
    }
  }, [logoutData, history]);

  useEffect(() => {
    if (FetchCompanyDetails1 != null) {
      if (FetchCompanyDetails1.status == true) {
        setTextcolor(FetchCompanyDetails1.data[0]?.textcolor);
        setFetchCompanyThemRes(FetchCompanyDetails1?.data);
      }
    }
  }, [FetchCompanyDetails1]);

  React.useEffect(() => {
    dispatch(getChatRooms(userID));
  }, []);

  React.useEffect(() => {
    let unreadMessages = 0;
    if (chatRoomsResponse.length > 0) {
      chatRoomsResponse?.map((room) => {
        if (room.unreadreceivermessagecount > 0) {
          unreadMessages += 1;
        }
      });
    }
    setTotalMessages(unreadMessages);
  }, [chatRoomsResponse]);

  const handleOpenMobileSidebarClick = () => {
    document.body.classList.add("mobile-sidebar-open");
  };

  /// ASC CLOSE DROP DOWN CLICK OUT SIDE START ///
  const kebabRef = useRef();

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, false);
    return () => {
      document.removeEventListener("click", handleClickOutside, false);
    };
  }, []);

  const handleClickOutside = (event) => {
    if (kebabRef.current && !kebabRef.current.contains(event.target)) {
      setShowpopup(false);
    }
  };
  /// ASC CLOSE DROP DOWN CLICK OUT SIDE END ///

  const logoutURL = localStorage.getItem("logoutUrl");

  return (
    <>
      <div className="app-header">
        <div className="app-mobile-header-left">
          {!isWebView() && (
            <div onClick={() => handleOpenMobileSidebarClick()}>
              <img src={MobileMenu} title="mobile-menu" />
            </div>
          )}
          <img
            className="app-header-logo-small"
            src={FetchCompanyThemRes[0]?.companylogo}
            alt="logo"
          />
        </div>
        <div className="app-web-header-left">
          {props.leftComponent && props.leftComponent}
          {path === "/planboard" && timerRunning && (
            <div
              className="track-time-box"
              style={{
                backgroundColor: "rgb(0, 36, 106)",
                width: "fit-content",
                marginTop: "0",
                padding: "0 12px",
                gap: "10px",
                justifyContent: "space-between",
              }}
            >
              <img
                src={Stop}
                alt=""
                onClick={() => {
                  if (timerType === "AssetMaintainance") {
                    localStorage.setItem("activeTab", "maintenance");
                    let redirect = localStorage.getItem("timerForAssetType");
                    history.push({
                      // pathname: "/asset-management/update-part",
                      pathname: redirect,
                      state: {
                        from: "Header_To_Open_Work_Modal",
                        data: taskId,
                      },
                    });
                    dispatch(StopTimerFromHeader(taskId));
                  } else {
                    dispatch(StopTimerFromHeader(taskId));
                  }
                }}
              />
              <p style={{ margin: "0", color: "#ffffff", minWidth: "4.5rem" }}>
                {session1}:{session2}:{session3}
              </p>
              <p
                className="margin-0 start-text"
                style={{ color: "#ffffff" }}
                onClick={() => {
                  if (timerType === "AssetMaintainance") {
                    localStorage.setItem("activeTab", "maintenance");
                    let redirect = localStorage.getItem("timerForAssetType");
                    history.push({
                      // pathname: "/asset-management/update-part",
                      pathname: redirect,
                      state: {
                        from: "Header_To_Open_Work_Modal",
                        data: taskId,
                        // clientName: item.clientname,
                        // clientId: item.clientid,
                      },
                    });
                  } else {
                    dispatch(OpenTimerFromHeader(taskId));
                  }
                }}
              >
                ({taskName})
              </p>
            </div>
          )}
        </div>

        <div className="app-header-right">
          {!Boolean(props.hideSearch) && (
            <div className="app-web-search-bar">
              <SearchInputComponent
                onChange={(value) => props.setQuery && props.setQuery(value)}
              />
            </div>
          )}
          {!isWebView() && <NotificationBell />}
          <Link to="/chat" style={{ position: "relative" }}>
            {totalMessages > 0 && (
              <div
                className="message-icon-main noty-iconspoint"
                style={{
                  backgroundColor: "#95A7C6",
                }}
              >
                <span
                  style={{
                    color: "white",
                    fontSize: "8px",
                    fontWeight: "500",
                  }}
                >
                  {totalMessages}
                </span>
              </div>
            )}
            <Image width={22} height={24} src={messageImage} />
          </Link>
          <div className="avatar position-relative" ref={kebabRef}>
            {userimag ? (
              <img
                alt=""
                src={userimag}
                height="32px"
                width="32px"
                className="profileButton"
                onClick={() => {
                  setShowpopup(!showpopup);
                }}
              />
            ) : (
              <div className="">
                <div
                  className="profileButton"
                  onClick={() => {
                    setShowpopup(!showpopup);
                  }}
                >
                  {/* below is for abbr using names */}
                  {/* {userlastname
                    ? `${userfirstname[0]?.toUpperCase()}${userlastname[1]?.toUpperCase()}`
                    : userfirstname?.slice(0, 2)?.toUpperCase()} */}
                  {/* below is for using initials from login API */}
                  {initials ?? ""}
                </div>
              </div>
            )}

            {showpopup && (
              <div className="popupcard rounded">
                <div
                  className="popupfirst"
                  onClick={() => {
                    setShowpopup(false);
                  }}
                >
                  <div
                    className="mt-4 mb-3"
                    style={{ display: "flex", justifyContent: "center" }}
                  >
                    {userimag ? (
                      <img className="imgpopup" src={userimag} alt="" />
                    ) : (
                      <p className="profilebtn">
                        {/* below is for abbr using names */}
                        {/* {userlastname
                          ? userfirstname[0]?.toUpperCase() +
                            "" +
                            userlastname[0]?.toUpperCase()
                          : userfirstname.slice(0, 2).toUpperCase()} */}

                        {/* below is for using initials from login API */}
                        {initials ?? ""}
                      </p>
                    )}
                  </div>
                  <h6
                    className="fw-bold luna"
                    style={{ color: `${textcolor}` }}
                  >
                    {/* {userlastname ? `${userfirstname} ${userlastname}` : userfirstname} */}
                    {userfirstname}
                  </h6>
                  <h6 className="managerrole" style={{ color: `${textcolor}` }}>
                    {" "}
                    {userjobpost === "null" ? "" : userjobpost}
                  </h6>
                </div>
                <div className="popupsecond">
                  <div className="py-4">
                    <div
                      // className="editpro1 d-flex gap-3 ps-4"
                      className={
                        isWebView() === true
                          ? "d-none editpro1 d-flex gap-3 ps-4"
                          : "editpro1 d-flex gap-3 ps-4"
                      }
                    >
                      <img src={editIcon} alt="" width={15} />
                      <p
                        className="py-2 mb-0 pointer"
                        onClick={() => {
                          history.push("/profile");
                        }}
                      >
                        {t("Edit profile")}
                      </p>
                    </div>

                    {props.SpireConnectConnection &&
                      props.SpireConnectConnection}

                    <div className="d-flex gap-3 dropdown-item logoutpop ps-4 py-2">
                      <img src={logOut} alt="" width={15} />
                      <p
                        className="mb-0"
                        onClick={() => {
                          if (timerRunning) {
                            return handleGeneralNotification(
                              {
                                notificationType: "CUSTOM",
                                text: `Please stop the timer in "${taskName}" before logging out!`,
                              },
                              true,
                            );
                          }
                          dispatch(user_logout(userID));
                          localStorage.removeItem("myAppName");
                          localStorage.setItem("logoutUrl", logoutURL);
                        }}
                        style={{ color: `${textcolor}`, cursor: "pointer" }}
                      >
                        {t("Log out")}
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {!Boolean(props.hideSearch) && screenSize !== "xs" && (
        <div className="app-mobile-search-bar">
          <SearchInputComponent
            onChange={(value) => props.setQuery && props.setQuery(value)}
          />
        </div>
      )}
    </>
  );
};

const SearchInputComponent = ({ onChange }) => {
  const refSearchInput = useRef();

  const handleSerachIconClick = () => {
    if (refSearchInput && refSearchInput.current) {
      if (refSearchInput.current.classList.contains("open")) {
        refSearchInput.current.value = "";
        refSearchInput.current.classList.remove("open");
        onChange("");
      } else {
        refSearchInput.current.classList.add("open");
        refSearchInput.current.focus();
      }
    }
  };

  // document.getElementById("asc")?.focus();

  return (
    <>
      <input
        id="asc"
        ref={refSearchInput}
        type="text"
        placeholder="Search..."
        title=""
        className="app-search-input ps-2"
        onChange={(e) => onChange(e.target.value)}
      />
      <div className="app-search-input-icon" onClick={handleSerachIconClick}>
        <Search className="search-icon" />
      </div>
    </>
  );
};

export default memo(Header);
